import { render } from "./AppointmentApproval.vue?vue&type=template&id=074ad4f2&scoped=true"
import script from "./AppointmentApproval.vue?vue&type=script&lang=js"
export * from "./AppointmentApproval.vue?vue&type=script&lang=js"

import "./AppointmentApproval.vue?vue&type=style&index=0&id=074ad4f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074ad4f2"]])

export default __exports__